import { makeStyles } from '@mui/styles';

const style = makeStyles((theme?: any) => ({
  segment: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
    textAlign: 'center',
  },
  itemsContainer: {
    justifyContent: 'center',
    '& > div': {
      marginTop: '35px',
    },
  },
  mainHeading: {
    marginBottom: theme.spacing(3),
  },
  content: {
    marginBottom: theme.spacing(2),
  },
  [theme.breakpoints.up('md')]: {
    itemsContainer: {
      justifyContent: 'space-between',
    },
    mainHeading: {
      marginBottom: theme.spacing(6),
    },
  },
}));

export default style;
